import { defineMessages } from "react-intl";

export const contextualLinks = defineMessages({
  devModePanel: {
    defaultMessage: "API reference and development guide for working with dashboard.",
    id: "zRIsjN",
  },
  apiReference: {
    defaultMessage: "API reference",
    id: "Zvo5iu",
  },
  apiGuide: {
    defaultMessage: "API guide",
    id: "BA4leV",
  },
  webhooks: {
    defaultMessage: "Extend dashboard using Webhooks for custom integrations and automation.",
    id: "zT1CvH",
  },
  extendingSaleor: {
    defaultMessage: "Extending dashboard with Webhooks",
    id: "B8PvdI",
  },
  staffMembers: {
    defaultMessage: "Manage staff roles and assign user permissions effectively.",
    id: "19o9WS",
  },
  userPermissions: {
    defaultMessage: "User permissions",
    id: "5M+hLZ",
  },
  orders: {
    defaultMessage: "Order processing, fulfillment, and management within dashboard.",
    id: "tl1/1E",
  },
  orderManagement: {
    defaultMessage: "Order management",
    id: "91vQMc",
  },
  products: {
    defaultMessage: "Set up and configure products, attributes, and categories in your catalog.",
    id: "C9cgck",
  },
  productConfigurations: {
    defaultMessage: "Product configurations",
    id: "dVk241",
  },
  giftCards: {
    defaultMessage: "Create, manage, and redeem gift cards within the platform.",
    description: "gift cards page subheader",
    id: "sOlOZB",
  },
  giftCardsDocs: {
    description: "gift cards docs link",
    defaultMessage: "Gift cards",
    id: "aBpkVh",
  },
  extensions: {
    defaultMessage: "Manage extensions for added functionality.",
    description: "extensions page subheader",
    id: "yeX6fA",
  },
  extensionsDocs: {
    defaultMessage: "Extensions",
    description: "extensions page subheader",
    id: "hVwc73",
  },
});
